/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2015, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../../lib/@waca/dashboard-common/dist/glass/controllers/WidgetBaseActionHandler',
	'../../../app/nls/StringResources',
	'../../../lib/@waca/core-client/js/core-client/utils/ClassFactory',
	'underscore'
], function(BaseClass, stringResources, ClassFactory,  _) {

	var ActionHandler = BaseClass.extend({

		getDashboardView: function(context) {
			return context.glassContext.appController.getCurrentContentView();
		},

		getUiHelperClass: function(){
			return ClassFactory.loadModule('dashboard-core/js/lib/@waca/dashboard-common/dist/ui/WidgetAddUIHelper');
		},

		getOptions: function(context) {
			const view = this.getDashboardView(context);
			const options = {
				module: 'dashboard-core/js/dashboard/views/CustomWidgetListView',
				label: stringResources.get('customWidgetsTitle'),
				getEntries: this.getEntries.bind(this),
				className: 'customWidgetSlideout',
				services: view.services,
				dashboardApi: this._getDashboardApi(view)
			};
			this.logger = this._getDashboardApi(view).getFeature('Logger');

			return this._createWidgetAddUIHelper(context)
				.then( () => {
					options.onItemClick =  this._onItemClickHandler.bind(this);
					options.onItemStartDrag = this.widgetAddUIHelper.addWidgetByDrag.bind(this.widgetAddUIHelper);
					return options;
				});
		},

		_onItemClickHandler: function(entry, event) {
			if (this._getContentTypeRegistryFeature().isTypeRegistered(entry.type)) {
				const canvas = this.dashboardApi.getFeature('Canvas');
				return canvas.addContent(entry.defaultSpec).catch((error) => {
					this.logger.log(error);
				});
			}
			return this.widgetAddUIHelper.addWidgetBySelection(entry, event);
		},

		getEntries: function(context) {
			return this._createWidgetAddUIHelper(context)
				.then( () => this.widgetAddUIHelper.fetchWidgetListFromPerspective('com.ibm.bi.dashboard.widgets', context.glassContext))
				.then( entries => {
					entries.list = _.filter(entries.list, function(entry) {
						return entry.builtin ? false : true;
					});
					entries.list = entries.list.concat(this._getContentTypeRegistryFeature().getExposedContents());
					return entries;
				});
		},

		_getDashboardApi(view) {
			if(!this.dashboardApi){
				this.dashboardApi = view.getDashboardApi();
			}
			return this.dashboardApi;
		},

		_getContentTypeRegistryFeature() {
			if(!this.contentTypeRegistry){
				this.contentTypeRegistry = this.dashboardApi.getFeature('ContentTypeRegistry');
			}
			return this.contentTypeRegistry;
		},

		// Private

		_createWidgetAddUIHelper: function(context) {
			const view = this.getDashboardView(context);
			this.uiHelperClassOptions = {
				services: view.services,
				dashboardApi: this._getDashboardApi(view)
			};

			return this.getUiHelperClass().then( UIHelperClass => {
				if(!this.widgetAddUIHelper) {
					this.widgetAddUIHelper = new UIHelperClass(this.uiHelperClassOptions);
				}
				this.widgetAddUIHelper.panelAttributes = {
					cdnUrl: this._getDashboardApi(view).getCDNUrl(),
					glassContext: context.glassContext
				};
				return this.widgetAddUIHelper;
			});
		}

	});

	return ActionHandler;
});
